/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamRoleResponseSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  instanceId: z.string().nullish(),
  isCritical: z.boolean(),
  isDefault: z.boolean(),
  lastSyncedAt: z.iso.datetime().nullish(),
  memberCount: z.int(),
  name: z.string(),
  openPositionCount: z.int(),
  sourceId: z.string().nullish(),
  teamCount: z.int(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
